import DbService from 'resources/db.service';
import schema from './deal-event.schema';

const service = new DbService('deal_events', { schema });

const createDealEvent = async ({
  type,
  dealId,
  companyId,
  data,
  createdBy,
}) => {
  const dealEventResult = await service.create({
    deal_id: dealId,
    company_id: companyId,
    type,
    data,
    created_by: createdBy,
  });

  return dealEventResult.data[0];
};

const getDealEventsByDealId = async (dealId, type) => {
  // let response = await service
  //   .select()
  //   .not('deal_id', 'is', null)
  //   .match({
  //     deal_id: dealId,
  //     ...(type && { type }),
  //   })
  //   .order('created_on', { ascending: false });

  let response = await service.selectByKey({
    selectKey: 'getDealEventsByDealId',
    params: { dealId, type },
  });

  response = service.processResponse(response);

  return response.data.length > 0 ? response.data : null;
};

export default Object.assign(service, {
  createDealEvent,
  getDealEventsByDealId,
});
